var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("compute-stock")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("compute-stock-to-date-enabled") },
                    model: {
                      value: _vm.dateLimitEnabled,
                      callback: function ($$v) {
                        _vm.dateLimitEnabled = $$v
                      },
                      expression: "dateLimitEnabled",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      disabled: !_vm.dateLimitEnabled,
                      fancy: "",
                      label: _vm.$ct("compute-stock-to-date"),
                    },
                    model: {
                      value: _vm.dateLimit,
                      callback: function ($$v) {
                        _vm.dateLimit = $$v
                      },
                      expression: "dateLimit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "play" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.run")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }